import moment from 'moment'
import Loader from '../../../../Global/Spinner'
import { Link, useHistory } from 'react-router-dom'

const ActivitiAttentionReports = ({ reports, loading, statusIds }) => {
  // STATES
  const history = useHistory()

  //---- FUNCTIONS ----//
  const handleToReportsDetails = () => {
    localStorage.setItem(
      'filtersReports',
      JSON.stringify({
        status_id: statusIds || [],
        dateTo: moment().subtract(1, 'week').format('YYYY-MM-DD'),
        jurisdiction_id: null,
        sub_jurisdiction_id: null,
        zone_id: null,
        colony_id: null,
        group_category_sub_id: null,
        nameColumnDateType: 'start_date',
        dateFrom: null,
        own_reports: null,
      })
    )
    localStorage.setItem('filtersReportsSearchQuery', JSON.stringify(null))
    return history.push(`/reports`)
  }

  return (
    <div className="row px-2 pb-3">
      <div className="col-12 card-activity-container">
        <div className="activity-header">
          <h6>Actividad que requiere atención</h6>
          <button
            className="btn btn-migrates"
            onClick={handleToReportsDetails}
          >
            Ver todo
          </button>
        </div>
        {loading ? (
          <Loader size="2rem" />
        ) : reports.length === 0 ? (
          <div className="alert alert-default-warning">
            Por el momento no hay informacion
          </div>
        ) : (
          reports.map((item, index) => (
            <div className="activity-item" key={index}>
              <div className="item-icon">
                <i className="fas fa-id-badge iconColor1" />
              </div>
              <div className="item-details">
                <span className="details-title">
                  {item?.folio || item?.folio}
                </span>
                <span className="details-status">
                  Estatus: {item?.StatusOfReport?.name} <br />
                  {item?.channel_capture === 'web' && (
                    <span>
                      Ciudadano: {item?.ReportCitizenOfUsers?.name || 'N/A'}
                    </span>
                  )}
                  {(item?.channel_capture === 'web_gestor' ||
                    item?.channel_capture === 'web_anonymous') && (
                    <span>
                      Comunicante Interno: {item?.ReportToUsers?.name || 'N/A'}
                    </span>
                  )}
                  {item?.channel_capture === 'app' && (
                    <span>Ciudadano: {item?.ReportToUsers?.name || 'N/A'}</span>
                  )}
                  {item?.channel_capture === 'tlajochat' && (
                    <span>
                      Ciudadano: {item?.UserTlajoChatOfReport?.name || 'N/A'}
                    </span>
                  )}
                  <br />
                  {item?.ReportsToResponsible && (
                    <span>
                      Responsable: {item?.ReportsToResponsible?.name || 'N/A'}
                    </span>
                  )}
                  <br />
                </span>
              </div>
              <span className="item-time d-flex flex-column align-items-end">
                {item?.start_date
                  ? moment(item.start_date).format('dddd D[,] MMMM YYYY')
                  : ''}
                <br />
                <Link
                  className="btn btn-migrates btn-sm mb-1"
                  to={`reports/details/${item?.id}/show`}
                >
                  <i className="fas fa-eye mr-1" /> Ver
                </Link>
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default ActivitiAttentionReports
